import React from 'react';
import {STEPS} from '../constants';
import Money from '../../../Money';

interface SimpleSubBarProps {
  langStrings: Record<string, string>;
  addedTotal: number;
  step: string;
  setStep: React.Dispatch<React.SetStateAction<string>>;
}

const SimpleSubBar: React.FunctionComponent<SimpleSubBarProps> = ({
  langStrings,
  addedTotal,
  step,
  setStep
}: SimpleSubBarProps) => {
  const stepIndex: number = STEPS.findIndex(elem => elem === step);

  const handleContinueClick = (): void => {
    setStep(STEPS[stepIndex + 1]);
    window.scrollTo(0, 0);
  };

  return (
    <div className="simple-sub-bar">
      <div className="simple-sub-bar-content">
        <h4 className="simple-sub-bar-complete">
          {stepIndex + 1}{' '}
          {langStrings.of}{' '}
          {STEPS.length}{' '}
          {langStrings.stepsCompleted}
        </h4>
        <div className="simple-sub-bar-total">{langStrings.total}: <Money amount={addedTotal}/></div>
      </div>
      <button
        onClick={handleContinueClick}
        className="btn btn--primary simple-sub-bar-continue"
      >
        {langStrings.continue}
      </button>
    </div>
  );
};

export default SimpleSubBar;